module.exports = __webpack_public_path__ + "img/confirm-icon.svg";